import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,   // 5 minutes — consistent with App.tsx
      gcTime: 10 * 60 * 1000,     // 10 minutes garbage collection
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});